/** One legal document, rendered the same way everywhere it appears. */
export const LegalDoc = ({ doc, compact }) => (
  <article data-testid={`legal-doc-${doc.id}`}>
    <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
      <h2
        className={`font-display tracking-tight ${compact ? "text-xl" : "text-2xl sm:text-3xl"}`}
      >
        {doc.title}
      </h2>
      <p className="label">
        v{doc.version} · effective {doc.effective}
      </p>
    </div>
    <p className="mt-4 border-l border-[var(--line-hi)] pl-5 text-sm leading-relaxed text-zinc-300">
      {doc.summary}
    </p>
    <div className="mt-8 space-y-7">
      {doc.sections.map((s) => (
        <section key={s.heading}>
          <h3 className="font-data text-[11px] uppercase tracking-[0.16em] text-zinc-300">
            {s.heading}
          </h3>
          <div className="mt-3 space-y-3">
            {s.body.map((p) => (
              <p key={p.slice(0, 48)} className="text-sm leading-relaxed text-zinc-400">
                {p}
              </p>
            ))}
          </div>
        </section>
      ))}
    </div>
    <p className="mt-8 font-data text-[10px] leading-relaxed text-zinc-700">
      fingerprint {doc.hash?.slice(0, 32)}…
    </p>
  </article>
);

export default LegalDoc;
